import type { ProviderMatcher } from '../widgetMacroTypes.ts';

import { isUrlMatch, withUnit } from '../utils/urlMatcherUtils.ts';

const MATCH_URL = 'maps.google.com';
const PATTERN = /^https?:\/\/maps\.google\.com\/.+/;

const DEFAULT_WIDTH = '425px';
const DEFAULT_HEIGHT = '350px';

export const matchGoogleMaps: ProviderMatcher = (url, params) => {
	if (!isUrlMatch(url, MATCH_URL) || !PATTERN.test(url)) {
		return null;
	}
	return {
		kind: 'iframe',
		provider: 'Google Maps',
		embedUrl: `${url}&output=embed`,
		width: withUnit(params.width) ?? DEFAULT_WIDTH,
		height: withUnit(params.height) ?? DEFAULT_HEIGHT,
	};
};
